// Common actions
export const UPDATE_COMMON_CONFIG = "UPDATE_COMMON_CONFIG";
export const UPDATE_OPTION_CONFIG = "UPDATE_OPTION_CONFIG";
export const UPDATE_IS_VISIBILITY_ERROR = "UPDATE_IS_VISIBILITY_ERROR";

// Flag actions
export const UPDATE_IS_DATA_LOADED = "UPDATE_IS_DATA_LOADED";
export const UPDATE_IS_LOADING = "UPDATE_IS_LOADING";
export const UPDATE_IS_BACKGROUND_LOADING = "UPDATE_IS_BACKGROUND_LOADING";

// Data actions
export const UPDATE_VISIBILITY_COLUMN = "UPDATE_VISIBILITY_COLUMN";
export const UPDATE_VISIBILITY_ROW = "UPDATE_VISIBILITY_ROW";
export const UPDATE_VISIBILITY_DATA = "UPDATE_VISIBILITY_DATA";
export const UPDATE_VISIBILITY_CELL = "UPDATE_VISIBILITY_CELL";
export const COPY_VISIBILITY_CONFIG_TO_PDF = "COPY_VISIBILITY_CONFIG_TO_PDF";
export const UPDATE_BACKUP_DATA = "UPDATE_BACKUP_DATA";
export const COPY_BACKUP_DATA = "COPY_BACKUP_DATA";
export const RESET_VISIBILITY_DATA = "RESET_VISIBILITY_DATA";
export const UPDATE_RAW_DATA = "UPDATE_RAW_DATA";
